import { EventEmitter, Component, Input, Output, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Subject } from 'rxjs';
import { filter, debounceTime, map } from 'rxjs/operators';
import { InlineSVGModule } from 'ng-inline-svg';
import { TranslateModule, TranslateLoader, MissingTranslationHandler } from '@ngx-translate/core';
import { FGBTranslationLoader, FGBMissingTranslationHandler } from '@fgb/core';
import { HttpClient } from '@angular/common/http';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from 'ng-inline-svg';
import * as ɵngcc2 from '@angular/forms';
import * as ɵngcc3 from '@angular/common';
import * as ɵngcc4 from '@ngx-translate/core';

function NumberInputComponent_p_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p", 10);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("* ", ctx_r0.minMessage, "");
} }
function NumberInputComponent_p_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "p", 11);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("* ", ctx_r1.maxMessage, "");
} }
class NumberInputComponent {
    constructor() {
        this.isActive = true;
        this.minValue = 1;
        this.limitValueToRange = true;
        this.amountChange = new EventEmitter();
        this.outOfRange = false;
        this.outOfRangeChange = new EventEmitter();
        this.amountSubject = new Subject();
        this.showMinMessage = false;
        this.showMaxMessage = false;
    }
    ngOnInit() {
        if (!this.amount) {
            this.amount = this.minValue;
            this.amountSubject.next(this.amount);
        }
        this.onAmountEnter = this.amountSubject
            .asObservable()
            .pipe(filter((x) => x !== this.amount), debounceTime(300), map((x) => {
            x = this.validateAmount(x, true);
            return x;
        }))
            .subscribe((x) => {
            this.amount = x;
            this.amountSubject.next(this.amount);
            this.amountChange.emit(this.amount);
            this.outOfRangeChange.emit(this.isNumberOutOfRange());
        });
    }
    ngOnDestroy() {
        if (this.onAmountEnter) {
            this.onAmountEnter.unsubscribe();
        }
    }
    ngOnChanges() {
        this.amount = this.validateAmount(this.amount, false);
    }
    increment() {
        let amount = this.amount;
        if (this.amount < this.minValue) {
            amount = this.minValue;
        }
        else if (this.amount + this.incrementValue <= this.maxValue) {
            amount = this.amount + this.incrementValue;
        }
        this.showMinMessage = false;
        this.amountSubject.next(amount);
        this.amountChange.emit(amount);
    }
    decrement() {
        let amount = this.amount;
        if (this.amount > this.maxValue) {
            amount = this.maxValue;
        }
        else if (this.amount - this.incrementValue >= this.minValue) {
            amount = this.amount - this.incrementValue;
        }
        this.showMaxMessage = false;
        this.amountSubject.next(amount);
        this.amountChange.emit(amount);
    }
    isNumberOutOfRange() {
        return this.amount < this.minValue || this.amount > this.maxValue;
    }
    /** Valdiates the amount compared to the min and max value inputs and returns the correct amount after comparison */
    validateAmount(x, showMessages) {
        if (showMessages) {
            this.showMaxMessage = false;
            this.showMinMessage = false;
        }
        if (x > this.maxValue) {
            if (this.limitValueToRange) {
                x = this.maxValue;
            }
            if (showMessages) {
                this.showMaxMessage = true;
            }
        }
        else if (x < this.minValue) {
            if (this.limitValueToRange) {
                x = this.minValue;
            }
            if (showMessages) {
                this.showMinMessage = true;
            }
        }
        else {
            this.showMaxMessage = false;
            this.showMinMessage = false;
        }
        return x;
    }
}
NumberInputComponent.ɵfac = function NumberInputComponent_Factory(t) { return new (t || NumberInputComponent)(); };
NumberInputComponent.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: NumberInputComponent, selectors: [["fgbcl-number-input"]], inputs: { isActive: "isActive", minValue: "minValue", limitValueToRange: "limitValueToRange", outOfRange: "outOfRange", amount: "amount", maxValue: "maxValue", incrementValue: "incrementValue", minMessage: "minMessage", maxMessage: "maxMessage", theme: "theme" }, outputs: { amountChange: "amountChange", outOfRangeChange: "outOfRangeChange" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 13, vars: 16, consts: [[1, "form-group", "mr-3"], [1, "quantity-select-container"], [1, "quantity"], [1, "btn", "number-input-decrement-button", "py-0", "px-1", 3, "disabled", "click"], [1, "svg", "svg-primary", 3, "inlineSVG"], ["id", "amountInput", "type", "number", 1, "form-control", "bid-amount-input", "px-4", "text-center", 3, "ngModel", "disabled", "min", "max", "ngModelChange"], [1, "btn", "number-input-increment-button", "py-0", "px-1", 3, "disabled", "click"], [1, "errors"], ["class", "error", "id", "minMessage", 4, "ngIf"], ["class", "error", "id", "maxMessage", 4, "ngIf"], ["id", "minMessage", 1, "error"], ["id", "maxMessage", 1, "error"]], template: function NumberInputComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "button", 3);
        ɵngcc0.ɵɵlistener("click", function NumberInputComponent_Template_button_click_3_listener() { return ctx.decrement(); });
        ɵngcc0.ɵɵpipe(4, "translate");
        ɵngcc0.ɵɵelement(5, "div", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "input", 5);
        ɵngcc0.ɵɵlistener("ngModelChange", function NumberInputComponent_Template_input_ngModelChange_6_listener($event) { return ctx.amountSubject.next($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "button", 6);
        ɵngcc0.ɵɵlistener("click", function NumberInputComponent_Template_button_click_7_listener() { return ctx.increment(); });
        ɵngcc0.ɵɵpipe(8, "translate");
        ɵngcc0.ɵɵelement(9, "div", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(10, "div", 7);
        ɵngcc0.ɵɵtemplate(11, NumberInputComponent_p_11_Template, 2, 1, "p", 8);
        ɵngcc0.ɵɵtemplate(12, NumberInputComponent_p_12_Template, 2, 1, "p", 9);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("disabled", !ctx.isActive || ctx.amount <= ctx.minValue);
        ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind1(4, 12, "number.input.decrease.screenreader"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("inlineSVG", "assets/images/icons/minus.svg");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵpropertyInterpolate("min", ctx.minValue);
        ɵngcc0.ɵɵpropertyInterpolate("max", ctx.maxValue);
        ɵngcc0.ɵɵproperty("ngModel", ctx.amount)("disabled", !ctx.isActive);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("disabled", !ctx.isActive || ctx.amount >= ctx.maxValue);
        ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind1(8, 14, "number.input.increase.screenreader"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("inlineSVG", "assets/images/icons/plusicon.svg");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showMinMessage);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showMaxMessage);
    } }, directives: [ɵngcc1.InlineSVGDirective, ɵngcc2.NumberValueAccessor, ɵngcc2.DefaultValueAccessor, ɵngcc2.NgControlStatus, ɵngcc2.NgModel, ɵngcc3.NgIf], pipes: [ɵngcc4.TranslatePipe], styles: ["[_nghost-%COMP%]{width:100%}input[type=number][_ngcontent-%COMP%]::-webkit-inner-spin-button, input[type=number][_ngcontent-%COMP%]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.quantity-select-container[_ngcontent-%COMP%]{width:142px}.quantity-select-container[_ngcontent-%COMP%]   .quantity[_ngcontent-%COMP%]{display:flex;position:relative}.amount-input[_ngcontent-%COMP%]{border-radius:5px;display:inline;padding:7px 0;background:#f4f4f5;border:0;margin:0!important;text-align:center}.btn[_ngcontent-%COMP%], .error[_ngcontent-%COMP%], .form-group[_ngcontent-%COMP%]{margin-bottom:0}.error[_ngcontent-%COMP%]{font-size:12px;color:red}.form-control[_ngcontent-%COMP%]{height:34px}.number-input-decrement-button[_ngcontent-%COMP%], .number-input-increment-button[_ngcontent-%COMP%]{position:absolute;font-weight:700;margin-top:3px}.number-input-increment-button[_ngcontent-%COMP%]{right:4px}.number-input-decrement-button[_ngcontent-%COMP%]{left:4px}"] });
NumberInputComponent.ctorParameters = () => [];
NumberInputComponent.propDecorators = {
    isActive: [{ type: Input }],
    minValue: [{ type: Input }],
    maxValue: [{ type: Input }],
    incrementValue: [{ type: Input }],
    minMessage: [{ type: Input }],
    maxMessage: [{ type: Input }],
    amount: [{ type: Input }],
    theme: [{ type: Input }],
    limitValueToRange: [{ type: Input }],
    amountChange: [{ type: Output }],
    outOfRange: [{ type: Input }],
    outOfRangeChange: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NumberInputComponent, [{
        type: Component,
        args: [{
                selector: 'fgbcl-number-input',
                template: "<div class=\"form-group mr-3\">\r\n  <div class=\"quantity-select-container\">\r\n    <div class=\"quantity\">\r\n      <!-- Minus Button -->\r\n      <button\r\n        class=\"btn number-input-decrement-button py-0 px-1\"\r\n        (click)=\"decrement()\"\r\n        [disabled]=\"!isActive || amount <= minValue\"\r\n        attr.aria-label=\"{{ 'number.input.decrease.screenreader' | translate }}\"\r\n      >\r\n        <div class=\"svg svg-primary\" [inlineSVG]=\"'assets/images/icons/minus.svg'\"></div>\r\n      </button>\r\n      <!-- Input Field -->\r\n      <input\r\n        id=\"amountInput\"\r\n        type=\"number\"\r\n        [ngModel]=\"amount\"\r\n        (ngModelChange)=\"amountSubject.next($event)\"\r\n        class=\"form-control bid-amount-input px-4 text-center\"\r\n        [disabled]=\"!isActive\"\r\n        min=\"{{ minValue }}\"\r\n        max=\"{{ maxValue }}\"\r\n      />\r\n      <!-- Plus Button -->\r\n      <button\r\n        class=\"btn number-input-increment-button py-0 px-1\"\r\n        (click)=\"increment()\"\r\n        [disabled]=\"!isActive || amount >= maxValue\"\r\n        attr.aria-label=\"{{ 'number.input.increase.screenreader' | translate }}\"\r\n      >\r\n        <div class=\"svg svg-primary\" [inlineSVG]=\"'assets/images/icons/plusicon.svg'\"></div>\r\n      </button>\r\n    </div>\r\n  </div>\r\n</div>\r\n\r\n<!-- Errors-->\r\n<div class=\"errors\">\r\n  <p class=\"error\" id=\"minMessage\" *ngIf=\"showMinMessage\">* {{ minMessage }}</p>\r\n  <p class=\"error\" id=\"maxMessage\" *ngIf=\"showMaxMessage\">* {{ maxMessage }}</p>\r\n</div>\r\n",
                styles: [":host{width:100%}input[type=number]::-webkit-inner-spin-button,input[type=number]::-webkit-outer-spin-button{-webkit-appearance:none;margin:0}.quantity-select-container{width:142px}.quantity-select-container .quantity{display:flex;position:relative}.amount-input{border-radius:5px;display:inline;padding:7px 0;background:#f4f4f5;border:0;margin:0!important;text-align:center}.btn,.error,.form-group{margin-bottom:0}.error{font-size:12px;color:red}.form-control{height:34px}.number-input-decrement-button,.number-input-increment-button{position:absolute;font-weight:700;margin-top:3px}.number-input-increment-button{right:4px}.number-input-decrement-button{left:4px}"]
            }]
    }], function () { return []; }, { isActive: [{
            type: Input
        }], minValue: [{
            type: Input
        }], limitValueToRange: [{
            type: Input
        }], amountChange: [{
            type: Output
        }], outOfRange: [{
            type: Input
        }], outOfRangeChange: [{
            type: Output
        }], amount: [{
            type: Input
        }], maxValue: [{
            type: Input
        }], incrementValue: [{
            type: Input
        }], minMessage: [{
            type: Input
        }], maxMessage: [{
            type: Input
        }], theme: [{
            type: Input
        }] }); })();

class NumberInputModule {
}
NumberInputModule.ɵfac = function NumberInputModule_Factory(t) { return new (t || NumberInputModule)(); };
NumberInputModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: NumberInputModule });
NumberInputModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            FormsModule,
            InlineSVGModule,
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useClass: FGBTranslationLoader,
                    deps: [HttpClient]
                },
                missingTranslationHandler: {
                    provide: MissingTranslationHandler,
                    useClass: FGBMissingTranslationHandler
                }
            }),
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NumberInputModule, { declarations: function () { return [NumberInputComponent]; }, imports: function () { return [CommonModule,
        FormsModule,
        InlineSVGModule, ɵngcc4.TranslateModule]; }, exports: function () { return [NumberInputComponent]; } }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NumberInputModule, [{
        type: NgModule,
        args: [{
                declarations: [NumberInputComponent],
                imports: [
                    CommonModule,
                    FormsModule,
                    InlineSVGModule,
                    TranslateModule.forRoot({
                        loader: {
                            provide: TranslateLoader,
                            useClass: FGBTranslationLoader,
                            deps: [HttpClient]
                        },
                        missingTranslationHandler: {
                            provide: MissingTranslationHandler,
                            useClass: FGBMissingTranslationHandler
                        }
                    }),
                ],
                exports: [NumberInputComponent]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { NumberInputComponent, NumberInputModule };

//# sourceMappingURL=fgb-portal-component-library-src-lib-shared-number-input.js.map